module.exports = __webpack_public_path__ + "media/images/Canada-bride-image3-b17794e3672c0a189c7477f757dbca04.jpg";